import React from 'react';

import { Button } from '../../components/Button/Button';
import { useInView } from '../../hooks/useInView';
import type { Hero } from './types';

import './HeroSection.css';

type HeroSectionProps = {
    data: Hero;
    nav?: React.ReactNode;
};

export function HeroSection({ data, nav }: HeroSectionProps) {
    const [ref, inView] = useInView<HTMLDivElement>();

    return (
        <section className="programs-hero">
            <div className="programs-hero__viewport">
                <img
                    className="programs-hero__bg"
                    src={data.backgroundImage}
                    alt=""
                    aria-hidden="true"
                />
                <div className="programs-hero__overlay" aria-hidden="true" />
                <div
                    ref={ref}
                    className={`programs-hero__copy faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
                >
                    <span className="programs-eyebrow faves-reveal">{data.eyebrow}</span>
                    <h1
                        className="programs-hero__heading faves-reveal"
                        style={{ '--reveal-delay': '120ms' } as React.CSSProperties}
                    >
                        {data.heading}
                    </h1>
                    <p
                        className="programs-hero__body faves-reveal"
                        style={{ '--reveal-delay': '240ms' } as React.CSSProperties}
                    >
                        {data.body}
                    </p>
                    <Button
                        label={data.cta.label}
                        href={data.cta.href}
                        variant="accent"
                        className="programs-hero__cta faves-reveal"
                    />
                </div>
                {nav && <div className="programs-hero__nav">{nav}</div>}
            </div>
        </section>
    );
}
